export const getAgentName = agentObject => {
  if (!agentObject) return 'N/A';

  const first = (agentObject?.first ?? '').trim();
  const last = (agentObject?.last ?? '').trim();

  const fullName = `${first} ${last}`.trim();

  return fullName || 'N/A';
};

export const getAgencyAddressLine = agency => {
  if (!agency) return 'N/A';

  const address1 = (agency?.address1 ?? '').trim();
  const address2 = (agency?.address2 ?? '').trim();

  const fullAddress = [address1, address2].filter(Boolean).join(' ');

  return fullAddress || 'N/A';
};

export const getAgencyLocationLine = agency => {
  if (!agency) return '';

  const city = (agency?.city ?? '').trim();
  const state = (agency?.state ?? '').trim();
  const zip = (agency?.zip ?? '').trim();

  const cityState = [city, state].filter(Boolean).join(', ');

  return [cityState, zip].filter(Boolean).join(' ');
};

export const getAgentLicenseNumber = license => license ?? 'N/A';
